export default function ChartGlobalEffect(): null {
  return null;
}
